import { useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import { Text, Field, RichText, NextImage, ImageField } from '@sitecore-jss/sitecore-jss-nextjs';
import { StNumber } from './InformationalBlock.style';
import useMediaQuery from '@mui/material/useMediaQuery';
import React from 'react';
import UiText from '../Typography/UiText';
import useApplyV2Theme from '../../../lib/hooks/useApplyV2Theme';
import { Typography } from '@mui/material';

type InformationalBlockProps = {
  stepNumber: Field<number>;
  stepTitle: Field<string>;
  stepDescription: Field<string>;
  hideStepNumbers: Field<boolean>;
  infoStepsVariantType: string;
  showTextBottom: boolean;
  alignItems: string;
  isVertical: boolean;
  invert: boolean;
  stepIcon: ImageField;
};

const InformationalBlock = (props: InformationalBlockProps): JSX.Element => {
  const {
    stepNumber,
    stepTitle,
    stepDescription,
    hideStepNumbers,
    showTextBottom,
    alignItems,
    isVertical,
    invert,
    stepIcon,
  } = props;

  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.down('lg'));
  const { isToapplyV2Theme } = useApplyV2Theme();
  const direction = React.useMemo(
    () => (showTextBottom && !matches ? 'column' : 'row'),
    [showTextBottom, matches]
  );
  const ColorVlaue = invert ? 'white' : 'primary';
  const numberLg = isVertical ? 1.5 : 3;
  const contentLg = isVertical ? 10.5 : 9;

  return (
    <Grid container flexDirection={direction} alignItems={alignItems} justifyContent="center">
      <Grid item xs={1.6} sm={1.6} md={1.8} lg={numberLg}>
        <StNumber invert={invert}>
          {hideStepNumbers?.value === false && <Text field={stepNumber} />}
        </StNumber>
        {stepIcon && hideStepNumbers?.value === false && !stepNumber?.value && (
          <Box justifyContent="center" display="flex">
            <NextImage
              field={stepIcon}
              style={{
                width: '100%',
                height: 'auto',
                maxWidth: '80px',
                paddingRight: '5px',
              }}
            />
          </Box>
        )}
      </Grid>
      <Grid item xs={10} sm={10} md={10.2} lg={contentLg}>
        <Box>
          {isToapplyV2Theme ? (
            <>
              {stepTitle?.value && <UiText color={ColorVlaue}>{stepTitle?.value}</UiText>}
              {stepDescription?.value && (
                <UiText color={ColorVlaue}>{stepDescription?.value}</UiText>
              )}
            </>
          ) : (
            <>
              {props?.stepTitle?.value && (
                <Typography
                  variant="h3"
                  color={invert ? theme.palette.white.main : theme.palette.themeColor.main}
                >
                  <Text field={props?.stepTitle} />
                </Typography>
              )}

              <Typography
                variant="description"
                color={invert ? theme.palette.white.main : theme.palette.text.primary}
              >
                <RichText field={props?.stepDescription} />
              </Typography>
            </>
          )}
        </Box>
      </Grid>
    </Grid>
  );
};

export default InformationalBlock;
